import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import AdminShell from "@/components/AdminShell";

const CARDS = [
  { key: "members", label: "Members", to: "/admin/members" },
  { key: "discussions_published", label: "Discussions", to: "/admin/discussions" },
  { key: "replies_published", label: "Replies", to: "/admin/replies" },
  { key: "categories", label: "Categories", to: "/admin/categories" },
  { key: "guides", label: "Published guides", to: "/admin/seo" },
  { key: "glossary", label: "Glossary terms", to: "/glossary" },
];

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setS(r.data)).catch(() => {}); }, []);

  const pending = s ? s.pending_threads + s.pending_replies : 0;

  return (
    <AdminShell active="dashboard" title="Dashboard" subtitle="A live, honest snapshot of the Circle.">
      {!s ? <p className="text-mutedplum">Loading…</p> : (
        <>
          {pending > 0 && (
            <Link to="/admin/moderation" data-testid="dash-pending-banner"
              className="block rounded-2xl bg-plum text-cream p-5 mb-6 hover:bg-plum-dark transition-colors">
              <span className="font-semibold">{pending}</span> item{pending === 1 ? "" : "s"} awaiting moderation — review now →
            </Link>
          )}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="dash-cards">
            {CARDS.map((c) => (
              <Link key={c.key} to={c.to} data-testid={`dash-card-${c.key}`}
                className="rounded-2xl bg-white border border-rose/30 shadow-card p-5 hover:-translate-y-0.5 transition-transform">
                <p className="text-4xl font-display text-plum">{s[c.key] ?? 0}</p>
                <p className="mt-1 text-sm text-mutedplum">{c.label}</p>
              </Link>
            ))}
          </div>
          <div className="mt-4 grid sm:grid-cols-3 gap-4">
            <div className="rounded-2xl bg-rose-soft p-5"><p className="text-2xl font-display text-plum">{s.new_today}</p><p className="text-sm text-mutedplum">New discussions today</p></div>
            <div className="rounded-2xl bg-rose-soft p-5"><p className="text-2xl font-display text-plum">{s.discussions_hidden}</p><p className="text-sm text-mutedplum">Hidden discussions</p></div>
            <div className="rounded-2xl bg-rose-soft p-5"><p className="text-2xl font-display text-plum">{s.moderators + s.admins}</p><p className="text-sm text-mutedplum">Team (mods + admins)</p></div>
          </div>
        </>
      )}
    </AdminShell>
  );
}
